import React, { ReactNode } from "react";
import { Helmet } from "react-helmet";
import { useTranslation } from "react-i18next";
import Sidebar from "src/components/layouts/sidebar/Sidebar";
import Breadcrumb from "src/components/layouts/Common/Breadcrumb";
import ShowTeacher from "src/components/panel/teachers/ShowTeacher/ShowTeacher";

const ShowTeacherView: React.FC = () => {
  const { t } = useTranslation();

  return (
    <>
      <Helmet>
        <title>{t("show_teacher_list_view")}</title>
      </Helmet>
      <Sidebar>
        <Breadcrumb title={t("show_teacher_list_title")} />
        <ShowTeacher />
      </Sidebar>
    </>
  );
};

export default ShowTeacherView;
